import React from 'react';

interface LegalLinksProps {
  className?: string;
}

const LINKS = [
  { href: '/terms', label: 'Terms of Service' },
  { href: '/privacy', label: 'Privacy Policy' },
  { href: '/refunds', label: 'Refunds & Cancellation' },
];

const LegalLinks: React.FC<LegalLinksProps> = ({ className = '' }) => (
  <nav
    aria-label="Legal"
    className={`flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-xs ${className}`}
  >
    {LINKS.map((link) => (
      <a
        key={link.href}
        href={link.href}
        className="text-inherit underline-offset-2 hover:underline"
      >
        {link.label}
      </a>
    ))}
  </nav>
);

export default LegalLinks;
